<div class="pay-order-general">
  <div class="pay-order-box">
    <div class="pay-order-title">
      <span>{{ 'pages.pay_order.title' | translate }}</span>
      <mat-icon class="info-icon" #myInfoTooltip="matTooltip"
        matTooltip="Se utiliza para ingresar el monto de la venta, previamente a que el cliente escanee el QR."
        (click)="myInfoTooltip.show()">info</mat-icon>
    </div>
    <br />
    <div class="container-form-qr">
      <form *ngIf="!generateQr" [formGroup]="form" autocomplete="off" (ngSubmit)="submit(form)">
        <!-- SUCURSALES -->
        <mat-form-field class="input-yaca" *ngIf="commerceUser || userResponsible" style="width: 100%">
          <mat-label *ngIf="!branchOfficeSelect">{{ 'pages.pay_order.branchs.select_branch' | translate }}</mat-label>
          <mat-label *ngIf="branchOfficeSelect">{{ 'pages.pay_order.branchs.branch' | translate }}</mat-label>
          <mat-select #branchMatSelect [(value)]="branchOfficeSelect" formControlName="branchSelected"
            (selectionChange)="selectionChangeBranch()"
            placeholder="{{ translate('pages.pay_order.branchs.select_branch') }}">
            <mat-option>
              <ngx-mat-select-search formControlName="searchBranch"
                placeholderLabel="{{ translate('pages.pay_order.branchs.search_branch') }}"
                noEntriesFoundLabel="{{ translate('pages.pay_order.branchs.branch_not_found') }}">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let branchOffice of branchFilter" [value]="branchOffice.value"
              (click)="viewBranch(branchOffice)">
              {{ branchOffice.display }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!branchSelected.untouched && branchSelected.invalid">
            {{ 'pages.pay_order.branchs.branch_error' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field class="input-yaca" style="width: 100%" *ngIf="oneBranch">
          <mat-label>{{ 'pages.pay_order.branchs.branch' | translate }}</mat-label>
          <input type="text" matInput value="{{ branchFilter[0].display }}" readonly style="cursor: pointer" />
        </mat-form-field>

        <!-- CASHIERS -->
        <mat-form-field class="input-yaca" *ngIf="(commerceUser || userResponsible) && !oneCashier" style="width: 100%">
          <mat-label *ngIf="!cashierSelect">{{ 'pages.pay_order.cashiers.select_cashier' | translate }}</mat-label>
          <mat-label *ngIf="cashierSelect">{{ 'pages.pay_order.cashiers.cashier' | translate }}</mat-label>
          <mat-select #cashierMatSelect [(value)]="cashierSelect" formControlName="cashierSelected"
            (selectionChange)="selectionChangeCashier()"
            placeholder="{{ translate('pages.pay_order.cashiers.select_cashier') }}"
            [disabled]="sucursalActual === null">
            <mat-option>
              <ngx-mat-select-search formControlName="searchCashier"
                placeholderLabel="{{ translate('pages.pay_order.cashiers.search_cashier') }}"
                noEntriesFoundLabel="{{ translate('pages.pay_order.cashiers.cashier_not_found') }}">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let cashier of cashierFilter" [value]="cashier.value">
              {{ cashier.display }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!cashierSelected.untouched && cashierSelected.invalid">{{
            'pages.pay_order.cashiers.cashier_error' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="input-yaca" style="width: 100%" *ngIf="oneCashier">
          <mat-label>{{ 'pages.pay_order.cashiers.cashier' | translate }}</mat-label>
          <input type="text" matInput value="{{ cashierFilter ? cashierFilter[0].display : '' }}" readonly
            style="cursor: pointer" />
        </mat-form-field>

        <!-- MONTO -->
        <div style="width: 100%">
          <div class="cont-monto">
            <span>{{ 'pages.pay_order.amount.amount' | translate }}</span>
            <mat-form-field class="input-amount-width">
              <input matInput #currencyInput [ngModel]="cashOutInputCurrency" (keypress)="keyPressNumbers($event)"
                class="input-monto" formControlName="monto" (ngModelChange)="monto = currencyInputChanged($event)"
                autocomplete="off" appCurrencyValidator type="tel" />
              <mat-error *ngIf="!this.montoDown">{{ getErrorMessage(6) }}</mat-error>
              <mat-error *ngIf="!this.montoDown">{{ getError }}</mat-error>
            </mat-form-field>
          </div>

          <mat-form-field class="input-yaca" style="width: 100%">
            <mat-label>{{ 'pages.pay_order.concept' | translate }}</mat-label>
            <input matInput type="text" placeholder="{{ translate('pages.pay_order.concept_placeholder') }}"
              formControlName="concept" />
          </mat-form-field>

          <div class="buttons">

            <button mat-stroked-button class="back"
              (click)="goBack()">
              Volver
            </button>

            <button *ngIf="oneCashier && !oneBranch" type="button" mat-raised-button class="button-width"
              (click)="continuePayment(form)" [ngClass]="{ 'button-cobrar': montoValid }"
              [disabled]="!(form.valid && montoValid)">
              {{ 'pages.pay_order.buttons.continue' | translate }}
            </button>

            <button *ngIf="!oneCashier && !oneBranch" type="button" mat-raised-button class="button-width"
              (click)="continuePayment(form)" [ngClass]="{ 'button-cobrar': montoValid }"
              [disabled]="!(form.valid && montoValid)">
              {{ 'pages.pay_order.buttons.continue' | translate }}
            </button>

            <button *ngIf="oneCashier && oneBranch" type="button" mat-raised-button class="button-width"
              (click)="continuePayment(form)" [ngClass]="{ 'button-cobrar': montoValid }" [disabled]="!montoValid">
              {{ 'pages.pay_order.buttons.continue' | translate }}
            </button>

            <button *ngIf="!oneCashier && oneBranch" type="button" mat-raised-button class="button-width"
              (click)="continuePayment(form)" [ngClass]="{ 'button-cobrar': montoValid }" [disabled]="!montoValid">
              {{ 'pages.pay_order.buttons.continue' | translate }}
            </button>
          </div>
        </div>
      </form>

      <div *ngIf="generateQr" class="qr-general-container">
        <div class="qr-container">
          <div class="warn-text">
            <span>Tu orden de pago fue generada, ya podés mostrarle el siguiente QR:
            </span>
            <mat-spinner *ngIf="loadingCashierName" [diameter]="20"></mat-spinner>
            <section class="qr-section">
              <div class="qr-container2">
                <div *ngIf="QRimgSrc === ''" style="padding: 20px">
                  <mat-spinner></mat-spinner>
                </div>
                <div>
                  <img class="qr-img" src="{{ QRimgSrc }}" *ngIf="QRimgSrc" />
                  <div #userQRCont id="userQR"></div>
                </div>
              </div>
            </section>
          </div>
        </div>


        <div class="container-buttons">
          <div>
            <button mat-stroked-button class="back"
              (click)="newQr()">
              Volver
            </button>
            <button mat-raised-button class="button-width button-cobrar" (click)="newQr()">Generar otra orden</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
